module.exports = __webpack_public_path__ + "img/app.3c84a072.png";